export const RowContainer: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <div className="border border-solid border-[#EEE] bg-white rounded-b-2xl">
      {children}
    </div>
  );
};
